import { Container } from 'pixi.js';
import { TextMetrics } from 'pixi.js';
import { RectangleElement } from '../primitive/rectangle-element';
import { PathElement } from '../primitive/path-element';
import { TextElement } from '../primitive/text-element';
import { TextLetter } from './text-letter';
import { IncrementController } from '../../../animation/frame/increment/controller/increment.controller';
import { TextAnimationConfig } from '../../../../elements/resource/types/shape.type';
import { TextLineNew } from './text-line-new';

export interface TextwordDescriptor {
  value: string;
  width: number;
  startCharacterIndex: number;
  letterWidths: number[];
}
export class TextWordNew {
  rect: RectangleElement;
  selected: Record<number, boolean> = {};

  get index() {
    return this.config.index;
  }

  get containerX() {
    return this.xOffset;
  }
  get containerY() {
    return this.config.lineYOffset + this.textShape.lineHeightOffset;
  }

  get lineIndex() {
    return this.parent.index;
  }
  get text() {
    return this.descriptor.text;
  }
  get textShpapeContainer() {
    return this.textShape.container;
  }

  get service() {
    return this.textShape.service;
  }

  get textShape() {
    return this.parent.textShape;
  }

  get length() {
    return this.word.length;
  }
  get firstLetter() {
    return this.letters[0];
  }

  get lastLetter() {
    return this.letters[this.letters.length - 1];
  }

  get cs() {
    return this.textShape.cs;
  }
  metric: TextMetrics;
  cursor: PathElement;

  get word() {
    return this.descriptor.text;
  }

  get xOffset() {
    return this.config.xOffset;
  }
  get end() {
    return this.config.xOffset + this.descriptor.width;
  }

  get prev() {
    return this.line.getPrevWord(this);
  }
  get nextWord() {
    return this.line.getNextWord(this);
  }

  get prevLine() {
    return this.line.prev;
  }

  get nextLine() {
    return this.line.next;
  }

  get leftOffset() {
    return this.config.leftOffset || 0;
  }

  get startCharacterIndex() {
    return this.config.startCharacterIndex;
  }

  get rightOffset() {
    return this.config.rightOffset || 0;
  }

  get line() {
    return this.parent;
  }

  get rectHeight() {
    return Math.min(this.textShape.baseLineHeight, this.metric.lineHeight);
  }

  get amILast() {
    return this.config.lineWordIndex == this.line.words.length - 1;
  }

  get cursorIsLastPosition() {
    return this.selectedIndex == this.word.length;
  }

  get lastCursorPositionInLine() {
    return this.line.wrapped && this.amILast && this.cursorIsLastPosition;
  }

  get amISpace() {
    return this.word == ' ';
  }
  leftRect: RectangleElement;
  rightRect: RectangleElement;
  textElement: TextElement;
  letters: TextLetter[] = [];
  doubleClickTookPlace = false;
  wholeTextSelectionBlock250ms = false;
  yOffset: number;
  charWidths: number[] = [];
  container: Container;
  globalIndex: number;
  constructor(
    public readonly parent: TextLineNew,
    private readonly descriptor: { text: string; width: number },
    private readonly config: {
      // x position of the word
      index: number;
      xOffset?: number;
      lineYOffset?: number;
      wordYOffset?: number;
      rightOffset?: number;
      leftOffset?: number;
      lineHeight: number;
      lineWordIndex: number;
      startCharacterIndex: number;
      // style: Text// ;
    },
  ) {
    // console.log('word', this.word, 'index', this.wordIndex); // -- //
    // this.metric = TextMetrics.measureText(this.word, this.style);
    // this.charWidths = Array.from(this.descriptor.value).map(
    //   char => TextMetrics.measureText(char, this.style).maxLineWidth,
    // );

    this.container = new Container();
    this.container.setTransform(
      this.xOffset,
      this.config.lineYOffset + this.textShape.lineHeightOffset,
    );

    this.parent.container.addChild(this.container);

    // -- // -- // -- // -- //
    // const fullLineHeight =
    //   this.textShape.lineHeight * this.textShape.baseLineHeight;
    // -- // -- //

    // let x = this.leftOffset;
    let x = 0;
    this.letters = Array.from(this.word).map((char, i) => {
      const letter = new TextLetter(this, {
        char: char as string,
        x,
        y: 0,
        height: this.line.cursorHeight,
        index: i,
        firstInLine: this.index == 0 && i == 0,
      });
      x += this.textShape.characterWidthMap[char as string];
      return letter;
    });
    // console.log('letters.length', this.letters.length);

    this.rect?.hide();

    if (this.leftOffset) {
      this.leftRect = new RectangleElement(
        this.textShape,
        this.textShape.container,
        {
          position: {
            x: this.xOffset - this.leftOffset,
            y: this.config.lineYOffset,
          },
          width: this.leftOffset,
          height: this.line.cursorHeight,
          fill: '#000000',
          opacity: 0.001,
        },
      );

      // if (this.textShape._isRoot) {
      this.leftRect.click(() => {
        if (!this.textShape.selected) {
          return;
        }
        this.showCursorByIndex(0);
      });

      this.addDragHandler(this.leftRect);
      // }
    }

    if (this.rightOffset) {
      this.rightRect = new RectangleElement(
        this.textShape,
        this.textShape.container,
        {
          position: {
            x: this.end,
            y: this.config.lineYOffset,
          },
          width: this.rightOffset,
          height: this.line.cursorHeight,
          fill: '#000000',
          opacity: 0.001,
        },
      );

      // if (this.textShape._isRoot) {
      this.rightRect.click(() => {
        if (!this.textShape.selected) {
          return;
        }
        this.showCursorByIndex(this.letters.length);
      });
      this.addDragHandler(this.rightRect);
      // }
    }
  }

  findLeterByX(x: number) {
    // if ()
    // return this.letters.find(letter => letter._isInMyRegion(x));
  }

  aboveLetter(letter: TextLetter) {
    return this.prev?.lastLetter;
  }

  belowLetter(letter: TextLetter) {
    return this.nextWord?.firstLetter;
  }

  nextLetter(letter: TextLetter) {
    if (letter.index == this.letters.length - 1) {
      return this.nextWord?.firstLetter;
    }
    return this.letters[letter.index + 1];
  }

  prevLetter(letter: TextLetter) {
    if (letter.index == 0) {
      return this.prev?.lastLetter;
    }
    return this.letters[letter.index - 1];
  }

  selectWord() {
    this.textShape._selectWord(this);
  }
  addDragHandler(rect: RectangleElement) {
    rect?.drag(
      (dx, dy) => {
        this.service.drag(dx, dy);
      },
      () =>
        this.service.startDrag(
          // this.parent.getType() == 'root-shape' ? null : this.parent,
          this.textShape,
        ),
      () => {
        this.service.endDrag();
      },
    );
  }

  animationState: {
    start: number;
    end: number;
    division: number;
    current: number;
    state: 'idle' | 'in-progress' | 'finished';
    config: TextAnimationConfig;
    // -- // -- // -- // -- //
  };

  floatIncrementController: IncrementController;
  opacityIncrementController: IncrementController;
  startAnimation(
    { start, end }: { start: number; end: number },
    config: TextAnimationConfig,
  ) {
    const division = end - start;
    this.animationState = {
      start,
      end,
      division,
      current: 0,
      state: 'idle',
      config,
    };

    const { type, scale, float, by } = config;

    this.opacityIncrementController = new IncrementController(0, 1, division);
    this.container.alpha = 0;

    // if (type == 'mask') {
    this.floatIncrementController = new IncrementController(
      this.textShape.netLineHeight / 2,
      0,
      division,
    );

    // this.container.setTransform()
    // }
    // this._letters.map(letter => {
    //   letter.element.patch({
    //     y: letter.y + this.textShape.netLineHeight / 2,
    //     opacity: 0,
    //   });
    // });
  }

  incrementAnimation(increment: number, index: number) {
    if (!this.animationState) {
      return;
    }

    this.animationState.current += increment;
    const { current, start, end, state } = this.animationState;

    if (state == 'finished') {
      return;
    }
    // -- //
    if (index == 0) {
      // console.log('state', this.animationState);
    }

    if (current < start) {
      return;
    }

    if (end < current && state == 'in-progress') {
      return this.endAnimation();
    }

    this.animationState.state = 'in-progress';

    if (this.floatIncrementController) {
      const dy = this.floatIncrementController.increment(increment);
      this.container.setTransform(this.containerX, this.containerY + dy);
    }

    const opacity = this.opacityIncrementController.increment(increment);
    this.container.alpha = opacity;
    // console.log('index', index ? 'bb' : 'aa', 'dy', dy, 'current', current);
    // this._letters.map(letter => {
    //   letter.element.patch({
    //     y: letter.y + dy,
    //     opacity: dOpacity,
    //   });
    // });
  }

  endAnimation() {
    if (!this.animationState) {
      return;
    }
    if (this.animationState.state == 'finished') {
      return;
    }

    console.log('finish animation');
    this.animationState.state = 'finished';

    if (this.floatIncrementController) {
      this.container.setTransform(this.containerX, this.containerY);
    }

    this.container.alpha = 1;
  }

  afterInit() {
    if (this.textShape.selectionStartIndex !== null) {
      // console.log(
      //   'startCharacterIndex',
      //   this.startCharacterIndex,
      //   'selectionStart',
      //   this.textShape.selectionStartIndex,
      // );
      // console.log('word', this.word, this.word.length);

      /* console.log(
        '---selection-start-index---',
        this.textShape.selectionStartIndex,
      ); */

      const index = this.textShape.selectionStartIndex;
      if (
        this.startCharacterIndex <= index &&
        index <= this.startCharacterIndex + this.word.length
      ) {
        this.showCursorByIndex(index - this.startCharacterIndex);
      }
    }
  }
  selectedIndex: number;
  selectionStartIndex: number;

  downWardSelect() {
    if (!this.nextLine) {
      return;
    }
  }

  currentCursorX: number;

  showCursorByIndex(index?: number) {
    if (!this.cs.isShiftPressed) {
      this.textShape.removeSelection();
    }

    this.cs.registerKeyDownHandler(key => this.textShape.keyDownHandler(key));

    if (this.amISpace) {
      // -- //
      if (index == 0 && !this.prev) {
        return;
      }
      // -- //

      if (index == undefined) {
        if (this.prev) {
          return this.prev?.showCursorByIndex();
        }
      } else {
        if (this.nextWord) {
          return this.nextWord?.showCursorByIndex(0);
        }
      }
    }

    // -- // -- // -- // -- // -- //
    if (index == undefined) {
      index = this.letters.length;
    }

    this.selectedIndex = index;

    this.currentCursorX = this.letters[index]
      ? this.letters[index].x
      : this.end;

    // this.textShape.selectionStartWord = this;

    this.textShape._showCursor(
      {
        x: this.xOffset + this.currentCursorX,
        y: this.config.lineYOffset,
        // y: this.lineIndex * this.metric.lineHeight - this.yOffset,
      },
      this,
    );
  }

  getXByIndex(index: number) {
    if (index == 0) {
      return this.xOffset;
    } else if (index < this.letters.length) {
      return this.letters[index].x;
    } else {
      return this.end;
    }
  }

  show() {
    // this.rect?.show();
    this.letters.map(letter => letter.show());
  }

  hide() {
    this.rect?.hide();
    this.letters.map(letter => letter.hide());
  }

  cursorRight() {
    console.log('cursor-right', this.selectedIndex);
    if (this.selectedIndex < this.letters.length) {
      console.log('if branch', this.letters.length, this.selectedIndex);
      this.showCursorByIndex(this.selectedIndex + 1);
    } else {
      console.log('else branch', this.letters.length, this.selectedIndex);
      this.nextWord?.showCursorByIndex(0);
    }

    // if (this.next) {
    //   this.next?.showCursorByIndex(0);
    // } else {
    //   this.nextLine?.words[0].showCursorByIndex(0);
    // }
  }

  cursorLeft() {
    // console.log('cursorLeft');
    // console.log('cursorLeft');
    if (0 < this.selectedIndex) {
      this.showCursorByIndex(this.selectedIndex - 1);
    } else {
      this.prev?.showCursorByIndex();
    }

    // if (this.prev) {
    //   this.prev.showCursorByIndex();
    // } else {
    //   this.prevLine?.words[this.prevLine.words.length - 1].showCursorByIndex();
    // }
  }
  findDownWord(strict = false): [TextWordNew, number] {
    return this.nextLine?.findWord(this.currentCursorX, strict);
  }
  findUpWord(strict = false): [TextWordNew, number] {
    return this.prevLine?.findWord(this.currentCursorX, strict);
  }

  cursorRightShift(): [TextWordNew, number] {
    if (this.selectionStartIndex < this.letters.length) {
      this.selectionStartIndex++;
      return [this, this.selectionStartIndex];
    }
    // -- // -- // -- //
    if (this.nextWord) {
      return [this.nextWord, 0];
    }
  }

  cursorLeftShift(): [TextWordNew, number] {
    if (0 < this.selectionStartIndex) {
      // this.lineIndex * this.metric.lineHeight;
      this.selectionStartIndex--;
      return [this, this.selectionStartIndex];
    }

    if (this.prev) {
      return [this.prev, this.prev.letters.length];
    }
  }

  isInMyRegion(xRef: number, strict = false): [TextWordNew, number] {
    let lastLast = false;
    const index = this.letters.findIndex(({ x, width }, index) => {
      if (this.index == 0 && index == 0) {
        return xRef <= x + width / 2;
      }

      if (
        this.index == this.parent.words.length - 1 &&
        index == this.letters.length - 1
      ) {
        // console.log('---------- hey ----------', x - width / 2 <= xRef);
        lastLast = true;
        return true;
      }

      return x - width / 2 <= xRef && xRef <= x + width / 2;
    });

    if (index != -1) {
      if (index == 0) {
        // console.log('index == 0');
      }

      if (index == this.letters.length - 1) {
        // console.log('index == this._letters.length - 1');
      }
      return [this, lastLast ? undefined : index];
    }
  }

  remove() {
    this.rect?.remove();
    this.textElement?.remove();
    this.letters?.forEach(letter => letter.remove());
    this.leftRect?.remove();
    this.rightRect?.remove();
    this.cursor?.remove();
  }
}
